import AdobeNumberField from "../../../../AdobeAriaLib/AdobeNumberField";

interface IFormNumberInputWrapper {
    value: string
    label: string
    required: boolean
    onChange: Function,
    validateRule?: Function,
    validationError?: string
    autocomplete?: string
    name?: string
    inputType?: string
}

export default function FormNumberInputWrapper({ value, label, required, onChange, validateRule, validationError, autocomplete, name, inputType }: IFormNumberInputWrapper) {
    function handleChange(val: string) {
        onChange(val)
    }

    function isDisabled() {
        return false
    }

    return (
        <div>
            <AdobeNumberField
                value={value}
                onChangeText={handleChange}
                label={label}
                visibleLabel={true}
                required={required}
                className=""
                disabled={isDisabled()}
                max={undefined}
                min={0}
                validateRule={validateRule}
                validationError={validationError}
                autocomplete={autocomplete}
                name={name}
                inputType={inputType} />
        </div>
    )
}